import * as Types from '../constants/Types';
import Hotel from './../models/Hotel';
import { HOTEL } from '../constants/Define';
import { PAGINATION } from '../constants/Define';

const initialState = {
    isFetching: false,
    isFetched: false,
    hotels: [],
    allHotels: [],
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    detail: {
        hotel: new Hotel(),
    },
    tagGroups: [],
    hotelActives: [],
    isFetchClearCache: false,
    rateCompareList: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.HOTEL_All_SUCCESS:
            return { ...state, allHotels: action.hotels };
        case Types.HOTEL_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.HOTEL_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                hotels: action.hotels,
                pageSize: action.pageSize,
                pageIndex: action.pageIndex,
                totalCount: action.totalCount,
                totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize))
            };
        case Types.HOTEL_LIST_FAIL:
            return { ...state, isFetching: false, isFetched: true, hotels: [] };
        case Types.HOTEL_DETAIL_ACTION:
            return { ...state, isFetching: true, detail: initialState.detail };
        case Types.HOTEL_DETAIL_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                detail: { hotel: action.hotel, }
            };
        case Types.HOTEL_DETAIL_UPDATE_ACTION:
            return { ...state, isFetching: true };
        case Types.HOTEL_DETAIL_CREATE_ACTION:
            return { ...state, isFetching: true };

        case Types.HOTEL_TAG_GROUP_DETAIL_SKU_ACTION:
            return { ...state, isFetching: true };
        case Types.HOTEL_TAG_GROUP_DETAIL_SKU_SUCCESS:
            return { ...state, isFetching: false, tagGroups: action.tagsGroupDetail };
        case Types.HOTEL_TAG_GROUP_DETAIL_SKU_ACTIVE_ACTION:
            return { ...state, isFetching: true };
        case Types.HOTEL_TAG_GROUP_DETAIL_SKU_ACTIVE_SUCCESS:
            return { ...state, isFetching: false };
            
        case Types.HOTEL_DETAIL_FAIL:
            return { ...state, isFetching: false, isFetched: true };
        case Types.HOTEL_CREATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.HOTEL_CREATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.HOTEL_DELETE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.HOTEL_DELETE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.HOTEL_UPDATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.HOTEL_UPDATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.HOTEL_FAIL:
            return { ...state, isFetching: false, isFetchingUpdate: false, isFetched: true };
        case Types.HOTEL_ALL_ACTIVE_SUCCESS: 
            return { ...state, hotelActives: action.hotelActive }
        case Types.CLEAR_CACHE_ACTION:
            return { ...state, isFetching: true, isFetchClearCache: true };
        case Types.CLEAR_CACHE_SUCCESS:
            return { ...state, isFetching: false, isFetchClearCache: false };
        case Types.RATE_LIST_COMPARE_ACTION:
            return { ...state, isFetching: true, rateCompareList: [] };
        case Types.RATE_LIST_COMPARE_SUCCESS:
            return {
                ...state,
                isFetching: false,
                rateCompareList: action.rateCompareList.__data__,
            };
        case Types.RATE_LIST_COMPARE_FAIL:
            return { ...state, isFetching: false };
        default:
            return state;
    }
}
